import pipedreamToolTitles from "../../i18n/locales/en/pipedream-tools.json" with { type: "json" };

// NOTE: The generated `pipedreamTools` namespace carries the same keys in every
// locale (it is keyed by the raw Pipedream tool name), so the English file is a
// complete list of the names it can title.
const PIPEDREAM_TOOL_NAMES: ReadonlySet<string> = new Set(
  Object.keys(pipedreamToolTitles),
);

// NOTE: Asking i18next for a key it does not have is not a safe probe here: both
// the web and the mobile `parseMissingKeyHandler` log a console error and return
// the KEY itself, which overrides `defaultValue: ""`. A non-Pipedream tool such
// as `geocodePlaces` then reads back as a "title" equal to its own raw name, so
// the chat row showed the registry identifier and the NSAI-5856 humanized
// fallback was never reached. Checking membership first keeps the lookup from
// firing at all for a name the map cannot title.
export const isPipedreamToolName = (toolName: string): boolean =>
  PIPEDREAM_TOOL_NAMES.has(toolName);
